import { useState } from "react";
import type {
  WikiLoadState,
  WikiPage,
  WikiPermissions,
  WikiMode,
  WikiRevisionComparison,
} from "./wiki-types";
export function useWikiMode({
  page,
  permissions,
  onModeChange,
}: Readonly<{
  page: WikiLoadState<WikiPage | null>;
  permissions: WikiPermissions;
  onModeChange(mode: WikiMode): void;
}>) {
  const [diff, setDiff] = useState<WikiRevisionComparison | null>(null);
  const currentPage = page.status === "ready" ? page.data : null;
  const modeItems: Readonly<{ value: WikiMode; label: string }>[] = [
    { value: "read", label: "Read" },
  ];

  if (permissions.canEdit) modeItems.push({ value: "edit", label: "Edit" });

  if (currentPage) modeItems.push({ value: "history", label: "History" });

  function changeMode(value: WikiMode) {
    if (value === "history") setDiff(null);

    onModeChange(value);
  }
  return { diff, setDiff, modeItems, changeMode };
}
